import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/Icon';

const RELEASE_FORMAT_PHYSICAL = 'Physical';

export const ConfigurationInfo = ({
  releaseType,
  releaseSubtype,
  releaseFormat,
}: {
  releaseType: string;
  releaseSubtype: string;
  releaseFormat: string;
}) => {
  const { t } = useTranslation('ddex-console');

  const formatLabel =
    releaseFormat === RELEASE_FORMAT_PHYSICAL
      ? t('releaseFormatPhysical')
      : t('releaseFormatDigital');

  return (
    <div className="flex items-start gap-md">
      <div className="flex flex-col items-center">
        <p>
          <Icon
            type={
              releaseFormat === RELEASE_FORMAT_PHYSICAL
                ? 'record-vinyl'
                : 'album-collection'
            }
            variant="light"
            size="lg"
            role="img"
            aria-label={
              releaseFormat === RELEASE_FORMAT_PHYSICAL
                ? 'Physical release'
                : 'Digital release'
            }
          />
        </p>
        <p className="text-body-xs">{formatLabel}</p>
      </div>
      <div className="flex flex-col">
        <p>{releaseType}</p>
        <p className="text-body-xs text-subtle">{releaseSubtype}</p>
      </div>
    </div>
  );
};

ConfigurationInfo.displayName = 'ConfigurationInfo';
